var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhyUs4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.3882 16.0288C32.3375 15.8894 32.4388 15.75 32.5908 15.75H37.9328C39.8972 15.75 41.4911 16.5652 41.4768 18.5297V18.5297C41.456 21.4162 37.4521 26.25 34.5655 26.25H32.5908C32.4388 26.25 32.3375 26.1106 32.3882 25.9712C32.5908 25.5066 32.8947 25.0885 33.2999 24.7633L35.0727 23.3695C36.5922 22.1615 36.5922 19.8385 35.0727 18.6305L33.2999 17.2367C32.8947 16.9115 32.5908 16.4934 32.3882 16.0288Z",
    fill: "url(#paint0_linear_2088_11542)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.65089 16.0288C9.70154 15.8894 9.60024 15.75 9.44828 15.75H4.1063C2.14184 15.75 0.547999 16.5652 0.562217 18.5297V18.5297C0.583109 21.4162 4.58693 26.25 7.47353 26.25H9.44828C9.60024 26.25 9.70154 26.1106 9.65089 25.9712C9.44828 25.5066 9.14437 25.0885 8.73916 24.7633L6.96636 23.3695C5.44682 22.1615 5.44682 19.8385 6.96636 18.6305L8.73916 17.2367C9.14437 16.9115 9.44828 16.4934 9.65089 16.0288Z",
    fill: "url(#paint1_linear_2088_11542)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9429 18.9082L32.3825 17.6985C31.6274 17.144 31.2751 16.1863 31.3757 15.279L31.6274 13.3132C31.8288 11.5995 30.369 10.1377 28.6575 10.3393L26.6944 10.5914C25.7883 10.6922 24.8319 10.3393 24.2782 9.58326L23.0701 8.0207C22.013 6.65977 19.9492 6.65977 18.8921 8.0207L17.684 9.58326C17.1303 10.3393 16.1739 10.6922 15.2679 10.5914L13.3047 10.3393C11.5933 10.1377 10.1335 11.5995 10.3348 13.3132L10.5865 15.279C10.6872 16.1863 10.3348 17.144 9.57978 17.6985L8.01933 18.9082C6.66022 19.9667 6.66022 22.0333 8.01933 23.0918L9.57978 24.3015C10.3348 24.856 10.6872 25.8137 10.5865 26.721L10.3348 28.6868C10.1335 30.4005 11.5933 31.8623 13.3047 31.6607L15.2679 31.4086C16.1739 31.3078 17.1303 31.6607 17.684 32.4167L18.8921 33.9793C19.9492 35.3402 22.013 35.3402 23.0701 33.9793L24.2782 32.4167C24.8319 31.6607 25.7883 31.3078 26.6944 31.4086L28.6575 31.6607C30.369 31.8623 31.8288 30.4005 31.6274 28.6868L31.3757 26.721C31.2751 25.8137 31.6274 24.856 32.3825 24.3015L33.9429 23.0918C35.3524 22.0837 35.3524 19.9667 33.9429 18.9082ZM20.956 31.459C15.2175 31.459 10.5362 26.7714 10.5362 21.0252C10.5362 15.279 15.2175 10.5914 20.956 10.5914C26.6944 10.5914 31.3757 15.279 31.3757 21.0252C31.3757 26.7714 26.6944 31.459 20.956 31.459Z",
    fill: "url(#paint2_linear_2088_11542)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0558 12.25C16.2657 12.25 12.3644 16.1776 12.3644 21C12.3644 25.8224 16.2657 29.75 21.0558 29.75C25.846 29.75 29.7472 25.8224 29.7472 21C29.7472 16.1776 25.846 12.25 21.0558 12.25ZM25.6978 19.1108L20.1175 24.5795C19.9694 24.7287 19.7719 24.7287 19.6237 24.5795L16.3644 21.2486C16.2163 21.0994 16.2163 20.9006 16.3644 20.7514L17.6484 19.5582C17.7965 19.4091 17.9941 19.4588 18.1422 19.5582L19.6731 21.2486C19.8212 21.3977 20.0188 21.3977 20.1669 21.2486L23.9694 17.4205C24.1176 17.2713 24.3151 17.2713 24.4632 17.4205L25.6978 18.6136C25.846 18.7628 25.846 18.9616 25.6978 19.1108Z",
    fill: "url(#paint3_linear_2088_11542)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2088_11542",
    x1: 32.4737,
    y1: 16.3779,
    x2: 41.0238,
    y2: 17.182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A60BEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2248A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2088_11542",
    x1: 9.56535,
    y1: 16.3779,
    x2: 1.01523,
    y2: 17.182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A60BEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2248A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2088_11542",
    x1: 7.30291,
    y1: 8.67441,
    x2: 33.4645,
    y2: 11.5056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A60BEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2248A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2088_11542",
    x1: 5.83573,
    y1: 13.2965,
    x2: 28.1867,
    y2: 16.6376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A60BEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2248A6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyUs4);
export default __webpack_public_path__ + "static/media/why-us-4.0cc3212dcfd3977df5a58c4a539c7dba.svg";
export { ForwardRef as ReactComponent };